<template>
  <div class="policyDetails" v-loading="loadingFlag">
    <div class="details-title">{{ detailsObj.fileName }}</div>
    <div class="down-btn">
      <el-button type="primary" @click="openFile()">下载</el-button>
    </div>
    <div
      class="content"
      
    >
      <!-- <iframe class="iframe-class" :src="pdfUrl" frameborder="0"></iframe> -->
      <pdf
        v-for="item in pageTotal"
        :src="pdfUrl"
        :key="item"
        :page="item"
        @page-loaded="pageLoaded"
      ></pdf>
    </div>
  </div>
</template>

<script>
import { getFileById } from "@/api/common";
import { findPolicyFileDetail } from "@/api/policy";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      pdfUrl: "",
      detailsObj: {},
      pageTotal: "",
      pageLoadNum: 0,
      loadingFlag: true,
    };
  },
  components: {
    pdf,
  },
  mounted() {
    this.keyId = this.$route.query.keyId;
    this.findPolicyFileDetail();
  },
  methods: {
    async findPolicyFileDetail() {
      const res = await findPolicyFileDetail({
        keyId: this.keyId,
      });
      this.detailsObj = res.data.detail;
      this.fileItem = this.detailsObj.attachFiles.length && this.detailsObj.attachFiles[0];
      if(this.fileItem){
        this.getFileById();
      }
      
    },
    async getFileById(downFlag = 0) {
      const res = await getFileById({
        fileId: this.fileItem.fileId,
        moduleFlag: "policy",
        downFlag,
      });
      const src =
        "data:application/pdf;base64," +
        btoa(
          new Uint8Array(res.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
      this.pdfUrl = pdf.createLoadingTask(src, { withCredentials: false });
      this.pdfUrl.promise
        .then((pdf) => (this.pageTotal = pdf.numPages))
        .catch((error) => {
          this.loadingFlag = false;
        });
      if (downFlag == 1) {
        //const blob = new Blob([res], { type });
        let eleLink = document.createElement("a");
        eleLink.download = this.fileItem.fileName;
        eleLink.style.display = "none";
        eleLink.href = src;
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
      }
    },
    openFile() {
      this.getFileById(1);
    },
    pageLoaded() {
      this.pageLoadNum++;
      if (this.pageLoadNum == this.pageTotal) {
        this.loadingFlag = false;
        console.log(this.pageLoadNum, this.pageTotal, "pageLoaded");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.policyDetails {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .down-btn {
    position: absolute;
    right: 50px;
    top: 30px;
  }
  .details-title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 21px;
  }
  .content {
    width: 100%;
    height: 650px;
    overflow-y: scroll;
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/policy/policyDetails.vue